import {
  Align,
  BorderType,
  FontSize,
  FontWeight,
  IIcon,
  ILayoutItem,
  IUIItem,
  IAjaxAction,
  IButton,
  IValidationErrors,
  ComparisonOperator,
} from "./common";

export interface IJsonForm {
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  targetType?: string | undefined;
  title?: string | undefined;
  description?: string | undefined;
  footer?: IFormFooter | undefined;
  submit?: IAjaxAction | undefined;
  showDynamicProps?: boolean | undefined;
  bodyProperty?: string | undefined;
  sendAllFields?: boolean | undefined;
  overflow?: string;
  alwaysShowFooter?: boolean;
  alwaysEnableSubmit?: boolean;
  isWizard?: boolean;
  isAdminProps?: boolean;
  template?: string;
  boundProperties?: string[][];
  auxActions?: IButton[] | undefined;
  display?: FormDisplayOptions | undefined;
  icon?: string;
}

export interface IFormFooter {
  okText?: string | undefined | null;
  cancelText?: string | undefined;
  okIcon?: IIcon | undefined;
}

export enum ActionFormSize {
  sm = 300,
  md = 600,
  lg = 1100,
}

export enum FormThemes {
  Danger = "danger",
}

export enum Operation {
  Create = "create",
  Modify = "modify",
}

export interface FormDisplayOptions {
  size?: keyof typeof ActionFormSize;
  allowMaximize?: boolean;
  theme?: FormThemes;
  operation: Operation;
  doInitialGeneration?: boolean;
}

export interface IFormField {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  hideLabel?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: any;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  hidden?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  supportedOperators?: string[];
  note?: string;
  modelProperty?: string;
  selectPropertyName?: string;
  isStandalone?: boolean;
  copyEnabled?: boolean;
  compareOperator?: ComparisonOperator;
  generationRule?: string;
}
